import {
  AddOrderItemUpsellComboEvent,
  OrderAction,
  OrderEvent,
  UpsellProduct,
} from '@oolio-group/domain';

type UpsellComboStoreState = {
  upsellCombos: UpsellProduct[];
  showUpsellComboModal: boolean;
};
let state: UpsellComboStoreState = {
  upsellCombos: [],
  showUpsellComboModal: false,
};
const listeners = new Set<() => void>();

/**
 * A simple store to manage upsell combo state. Provides subscribe and getSnapshot methods.
 * Also includes a setState method to update the upsell combos and notify listeners.
 */
export const upsellComboStore = {
  subscribe: (callback: () => void) => {
    listeners.add(callback);
    return () => {
      listeners.delete(callback);
    };
  },
  getSnapshot: () => {
    return state;
  },
  notifyListeners: () => {
    listeners.forEach(listener => listener());
  },
  setState: (events: OrderEvent[]) => {
    const lastEvent = events[events.length - 1] as AddOrderItemUpsellComboEvent;
    if (lastEvent.action === OrderAction.ORDER_ITEM_SHOW_UPSELL_COMBOS) {
      const upsellProducts: UpsellProduct[] = lastEvent.upsellCombos ?? [];
      state = {
        upsellCombos: upsellProducts,
        showUpsellComboModal: !!upsellProducts.length,
      };
      upsellComboStore.notifyListeners();
    } else if (state.showUpsellComboModal) {
      state = {
        upsellCombos: [],
        showUpsellComboModal: false,
      };
      upsellComboStore.notifyListeners();
    }
  },
};
